import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.timelineConfig`;
export const INIT = `${SCOPE}/INIT`;
export const CHANGE_ZOOM_LEVEL = `${SCOPE}/CHANGE_ZOOM_LEVEL`;
export const UPDATE_ZOOM_LEVEL = `${SCOPE}/UPDATE_ZOOM_LEVEL`;
export const APPLY_TIMELINE_CONFIG = `${SCOPE}/APPLY_TIMELINE_CONFIG`;
export const TIMELINE_DETAIL_HIGHLIGHT = `${SCOPE}/TIMELINE_DETAIL_HIGHLIGHT`;
